import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';

import { GOOGLE_MAP_POPUP_DATA } from '@lib/geo/google/map';

@Component({
  selector: 'sn-polyline-info-popout',
  templateUrl: './polyline-info-popout.component.html',
  styleUrls: ['./polyline-info-popout.component.scss'],
})
export class PolylineInfoPopoutComponent implements OnInit {
  public text: string;
  constructor(
    @Inject(GOOGLE_MAP_POPUP_DATA) public data: any,
    private readonly _cd: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.text = this.data.unit || this.data.name;
    this._cd.detectChanges();
  }
}
